import {
    ToggleEditableCurbLink,
    TOGGLE_EDITABLE_CURB_LINK,
    AllCurbLinksOfSameRegulationIdReceived,
    ALL_CURB_LINK_OF_SAME_REGULATION_ID_RECEIVED,
    AllProposedCurbLinksOfSameRegulationIdReceived,
    ALL_PROPOSED_CURB_LINK_OF_SAME_REGULATION_ID_RECEIVED
} from "./types";
import { createAction } from "@reduxjs/toolkit";

export const toggleEditableCurbLink =
    createAction<ToggleEditableCurbLink["payload"]>(TOGGLE_EDITABLE_CURB_LINK);

export const allCurbLinksOfSameRegulationIdReceived = createAction<
    AllCurbLinksOfSameRegulationIdReceived["payload"]
>(ALL_CURB_LINK_OF_SAME_REGULATION_ID_RECEIVED);

export const allProposedCurbLinksOfSameRegulationIdReceived = createAction<
    AllProposedCurbLinksOfSameRegulationIdReceived["payload"]
>(ALL_PROPOSED_CURB_LINK_OF_SAME_REGULATION_ID_RECEIVED);
